import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistoryCommentSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#EEF1FC" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.62 9C9.17299 9 8 10.173 8 11.62V18.4244C8 19.8714 9.17299 21.0443 10.62 21.0443H19.8526L21.5162 22.737C22.0641 23.2945 23.0124 22.9066 23.0124 22.1249V18.6387L22.9842 18.65C22.9905 18.5756 22.9937 18.5004 22.9937 18.4244V11.62C22.9937 10.173 21.8208 9 20.3738 9H10.62Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default TaskHistoryCommentSVG;
